import { connect } from 'react-redux'

import {
  getCurrentUser,
  isAccountTypeRetailer,
  isProBrand,
  isProRetailer,
} from 'store/currentUser/selectors'
import { dismissTimestampedNews } from 'store/news/actions'
import { resetSelectedOrders, sortOrders } from 'store/orderList/actions'
import {
  setAppliedFiltersToCreatedByRetailers,
  toggleDeselectAllFilters,
  toggleSelectFilter,
} from 'store/orderListFilters/actions'
import {
  getAppliedFilters,
  getSearchFilter,
} from 'store/orderListFilters/selectors'

import OrderListPage from './OrderListPage'

const mapStateToProps = (state) => ({
  appliedFilters: getAppliedFilters(state),
  searchFilter: getSearchFilter(state),
  currentUser: getCurrentUser(state),
  isProRetailer: isProRetailer(state),
  isRetailer: isAccountTypeRetailer(state),
  isProBrand: isProBrand(state),
})

const mapDispatchToProps = (dispatch) => ({
  setAppliedFiltersToCreatedByRetailers: () =>
    dispatch(setAppliedFiltersToCreatedByRetailers()),
  handleResetSelectedOrders: () => dispatch(resetSelectedOrders()),
  dismissTimestampedNews: (action) => dispatch(dismissTimestampedNews(action)),
  sortOrders: (payload) => dispatch(sortOrders(payload)),
  toggleSelectFilter: (filter) => dispatch(toggleSelectFilter(filter)),
  toggleDeselectAllFilters: () => dispatch(toggleDeselectAllFilters()),
})

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default withRedux(OrderListPage)
